import HttpUtils from '@/framework/HttpUtils';
import { handelPromise } from '@/utils';
//获取游戏列表
export const getAccountBalance = async (): Promise<UserAccountInfo> => {
    return await handelPromise<any>(HttpUtils.Get('/ai-points/user-account-balance'));
};

export const getTokenRechargeRecord = async (): Promise<TokenRechargeRecord[]> => {
    return await handelPromise<any>(HttpUtils.Get('/ai-points/transaction-order-list'));
};
//用户提现
export const userWithdrawal = async (withdrawalReqSignature: WithdrawalReqSignature, currentTime: number): Promise<any> => {
    return await handelPromise<any>(HttpUtils.Post('/ai-points/user-withdrawal', withdrawalReqSignature, { CurrentTime: currentTime }));
};

export const userWithdrawalByOrderId = async (withdrawalReqSignature: WithdrawalReqSignature): Promise<any> => {
    return await handelPromise<any>(HttpUtils.Post('/ai-points/user-withdrawal-by-order-id', withdrawalReqSignature));
};
